import ApiService from '@/common/api.service'

import { getField, updateField } from 'vuex-map-fields';

/* eslint-disable */
const getDefaultState = () => {
  return {
    qpadmSampleForm: {
      id: 0,
      isActive: true,
      qpadmSampleDbType: null,
      qpadmSampleAgeType: null,
      label: null,
      subLabel: null,
      sampleID: null,
      snpCount: null,
      location: null,
      mtDNA: null,
      yDNATM: null,
      yDNAISOGG: null,
      datingMethod: null,
      date: null,
      study: null,
      locality: null,
      noUDG: null,
    },
  }
}

const state = getDefaultState()

const getters = {
  getQpadmSampleField(state) {
    return getField(state.qpadmSampleForm);
  },
  getQpadmSample(state) {
    return state.qpadmSampleForm;
  },
}

const mutations = { 
  updateQpadmSampleField(state, field) {
    updateField(state.qpadmSampleForm, field);
  },
  setQpadmSampleField(state, data) {
    state.qpadmSampleForm = data;
  },
  resetQpadmSampleField(state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  fetchQpadmSamples({}, queryParams) {
    return new Promise((resolve, reject) => {
      ApiService.get('QpadmSample/pagination', queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  fetchQpadmSample({}, queryParams) {
    return new Promise((resolve, reject) => {
      ApiService.get(`QpadmSample/${queryParams.id}`, queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  saveQpadmSample({}, queryParams) {
    return new Promise((resolve, reject) => {
      ApiService.post('QpadmSample', queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
